import React, { useState } from 'react';
import Loader from 'components/atoms/loader';
import AiManagementFilePreview from 'components/atoms/ai_management_file_preview';
import { EditalFile } from 'hooks/useEditalFiles';
import { biddingFileHref } from 'services/actions/ai_management_files';
import { formatDateTimeLong } from 'services/ai_management_dates';
import { Container } from './styles';

interface AiManagementBiddingFilesProps {
  files: EditalFile[];
  loading: boolean;
  error: boolean;
}

const AiManagementBiddingFiles: React.FC<AiManagementBiddingFilesProps> = ({
  files,
  loading,
  error,
}) => {
  const [expandedKey, setExpandedKey] = useState<string | null>(null);

  if (loading) {
    return (
      <div className="py-4">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-warning mb-0" role="alert">
        Não foi possível carregar os arquivos do edital.
      </div>
    );
  }

  if (!files.length) {
    return (
      <div className="text-muted">Nenhum arquivo de edital disponível para esta licitação.</div>
    );
  }

  return (
    <Container>
      <div className="files-card card border">
        <table className="table mb-0">
          <thead className="thead-light">
            <tr>
              <th scope="col">Nome do arquivo</th>
              <th scope="col">Data</th>
              <th scope="col" aria-label="Ações" />
            </tr>
          </thead>
          <tbody>
            {files.map((file) => {
              const expanded = expandedKey === file.key;
              return (
                <React.Fragment key={file.key}>
                  <tr>
                    <td className="file-name align-middle">
                      {file.name}
                      {file.archive && (
                        <small className="file-origin d-block text-muted">
                          {file.folder ? `${file.archive} / ${file.folder}` : file.archive}
                        </small>
                      )}
                    </td>
                    <td className="align-middle text-nowrap">
                      {file.modifiedAt ? formatDateTimeLong(file.modifiedAt) : '—'}
                    </td>
                    <td className="file-actions align-middle text-right text-nowrap">
                      <a
                        className="btn btn-outline-secondary btn-sm mr-1"
                        href={biddingFileHref(file.downloadUrl)}
                        download={file.name}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`Baixar ${file.name}`}
                      >
                        <i className="material-icons">file_download</i>
                      </a>
                      <button
                        type="button"
                        className="btn btn-secondary btn-sm"
                        onClick={() => setExpandedKey(expanded ? null : file.key)}
                        aria-expanded={expanded}
                        aria-label={expanded ? 'Fechar pré-visualização' : 'Pré-visualizar arquivo'}
                      >
                        <i className="material-icons">{expanded ? 'expand_less' : 'expand_more'}</i>
                      </button>
                    </td>
                  </tr>
                  {expanded && (
                    <tr className="file-preview-row">
                      <td colSpan={3} className="px-3 pb-3 pt-0">
                        <AiManagementFilePreview name={file.name} downloadUrl={file.downloadUrl} />
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </Container>
  );
};

export default AiManagementBiddingFiles;
